export default __webpack_public_path__ + "static/media/rotate.bd3e0b44.svg";